<template>
  <field-container
    :label="label"
    :required="required"
  >
    <form-toggle
      :value="value"
      :name="name"
      :error="error"
      :trueValue="trueValue"
      :falseValue="falseValue"
      :readonly="readonly"
      :placeholder="placeholder"
      :help-text="helpText"
      @input="input"
    ></form-toggle>
    <p class="font--14px inline-block pl--16px text--gray text--darken-2">{{helpText}}</p>
  </field-container>
</template>

<script>
export default {
  // name: 'text-field-toggle',
  props: {
    label: { type: String, required: true },
    value: { type: [String, Number], required: true },
    name: { type: String, required: true },
    error: { type: Object, required: true },
    trueValue: { type: [String, Boolean], default: true },
    falseValue: { type: [String, Boolean], default: false },
    readonly: { type: Boolean, default: false },
    required: { type: Boolean, default: false },
    placeholder: { type: String, default: '' },
    helpText: { type: String, default: '' }
  },
  methods: {
    input (value) {
      this.$emit('input', value)
    }
  },
  components: {
    FormToggle: () => import('@/component/ui2/form/FormToggle'),
    FieldContainer: () => import('@/component/ui2/uicontainer/FieldContainer')
  }
}
</script>
